import {Doughnut} from "vue-chartjs";
import updateChartMixin from "@/components/widgets/updateChartMixin";

export default {
    name: "generic-doughnut",
    extends: Doughnut,
    mixins: [updateChartMixin],
    props: {
        options: {
            type: Object,
            default: () => null
        },
        data: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.renderChart(this.data, this.options);
    },
    methods: {
        update(data) {
            this.renderChart(data, this.options);
        }
    }
};